<template>
  <el-drawer :title="isedit ? '编辑小票模板' : '新增小票模板'" :visible.sync="childdialogshow" :show-close="false"
    :destroy-on-close="true" :wrapperClosable="false" direction="rtl" ref="drawer" size="950px" :before-close="cancel">
    <div class="dialogshow">
      <div class="dialoForm-content">
        <el-row :gutter="20">
          <el-col :span="9">
            <el-alert title="小票模板预览" type="info" :closable="false">
            </el-alert>
            <div class="preview">
              <p class="previewtitle">
                {{ createform.TicketTitle }}
              </p>
              <p class="itemcenter">停车计时单</p>
              <div class="prbt"></div>
              <p class="item">车牌号码：川A88888</p>
              <p class="item">入场时间：2022-01-01 18:00:00</p>
              <p v-if="createform.HistoryAmountDisplay" class="item">历史欠费：20元</p>
              <p v-if="createform.EntrancecountDisplay" class="item">入场次数：本日第2次入场</p>
              <p class="item">停放路段：北京西路一段</p>
              <p class="item">泊位号：S0001</p>
              <p class="item">收费员编号：00001</p>
              <p v-if="createform.ScanType != 0" class="item">缴费二维码：</p>
              <div v-if="createform.ScanType != 0" style="text-align: center">
                <img src="@/assets/code.png" />
                <p v-if="createform.ScanType == 2" class="itemmax">请使用微信扫码缴费</p>
                <p v-if="createform.ScanType == 1" class="itemmax">请使用微信或支付宝扫码缴费</p>
                <p v-if="createform.ScanType == 3" class="itemmax">请使用支付宝扫码缴费</p>
              </div>
              <div class="prbt"></div>
              <p class="item">服务咨询电话：{{ createform.ServicePhone }}</p>
              <div v-if="createform.RateRemarkDisplay">
                <p class="item">
                  资费说明：{{
                    createform.RateRemark == null || createform.RateRemark == ""
                      ? ""
                  : createform.RateRemark
                  }}
                </p>
              </div>
              <div v-if="createform.RemindDisplay">
                <p class="item">温馨提醒：{{ createform.RemindRemark }}</p>
              </div>
              <div v-if="createform.ExtColMark">
                <p v-if="createform.ExtColName != '' && createform.ExtColName != undefined" class="item">{{
                  createform.ExtColName }}：{{ createform.ExtColValue
                  }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="15">
            <el-alert title="模板设置" type="info" :closable="false">
            </el-alert>
            <el-form class="dialoForm-form" ref="createform" :model="createform" label-width="120px" :rules="rules"
              style="width: 98%; margin-top: 10px">
              <el-form-item label="模板名称：" prop="TicketName">
                <el-input v-model="createform.TicketName" maxlength="10" show-word-limit autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="小票标题" prop="TicketTitle">
                <el-input v-model="createform.TicketTitle" maxlength="20" show-word-limit autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="打印入场次数：">
                <el-switch v-model="createform.EntrancecountDisplay"></el-switch>
                开启后将打印该车当日第几次入场
              </el-form-item>
              <el-form-item label="打印历史欠费：">
                <el-switch v-model="createform.HistoryAmountDisplay"></el-switch>
                开启后将打印该车历史欠费金额
              </el-form-item>
              <el-form-item label="扫码支持类型：">
                <el-select v-model="createform.ScanType">
                  <el-option label="微信和支付宝" :value="1"></el-option>
                  <el-option label="仅支持微信" :value="2"></el-option>
                  <el-option label="仅支持支付宝" :value="3"></el-option>
                  <el-option label="关闭" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="服务咨询电话：" prop="ServicePhone">
                <el-input v-model="createform.ServicePhone" maxlength="20" show-word-limit
                  autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="打印资费说明：">
                <el-switch v-model="createform.RateRemarkDisplay"></el-switch>
                <el-input :rows="4" v-if="createform.RateRemarkDisplay" type="textarea" v-model="createform.RateRemark"
                  maxlength="400" show-word-limit autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="打印温馨提醒：">
                <el-switch v-model="createform.RemindDisplay"></el-switch>
                <el-input :rows="4" v-if="createform.RemindDisplay" type="textarea" v-model="createform.RemindRemark"
                  maxlength="400" show-word-limit autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="打印自定义项：">
                <el-switch v-model="createform.ExtColMark"></el-switch>
                <div v-if="createform.ExtColMark">
                  自定义项名称：<el-input v-model="createform.ExtColName" maxlength="10" show-word-limit
                    autocomplete="off"></el-input>
                  自定义项说明：<el-input v-model="createform.ExtColValue" type="textarea" :rows="4" maxlength="200"
                    show-word-limit autocomplete="off"></el-input>
                </div>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <div class="dialoForm-footer">
        <el-button @click="cancel" style="width: 100px">取 消</el-button>
        <el-button style="width: 100px" type="primary" @click="save">保 存</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<style lang="less" scoped>
.preview {
  width: 300px;
  border: 1px solid #eee;
  margin: 0 auto;
  margin-top: 10px;
  box-sizing: border-box;
  padding: 15px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.1);

  .previewtitle {
    text-align: center;
    font-size: 16px;
    color: #333;
  }

  .prbt {
    border-top: 1px dashed #eee;
    margin: 10px 0;
    height: 1px;
  }

  .itemcenter {
    text-align: center;
    font-size: 12px;
  }

  .item {
    font-size: 14px;
  }

  .itemmax {
    font-size: 16px;
    font: bold;
  }

  .infotitle {
    display: flex;
    justify-content: space-between;

    span {
      flex: 0 0 33.333333%;
      text-align: center;
    }

    span:nth-child(1) {
      text-align: left;
    }

    span:nth-child(3) {
      text-align: right;
    }
  }

  .item_tr {
    display: flex;
    justify-content: space-between;
  }
}
</style>
<script>
import { create, edit } from "@/api/ticket";
export default {
  name: "addticket",
  props: {
    isedit: {
      required: true,
      type: Boolean,
    },
    dialogshow: {
      required: true,
      type: Boolean,
    },
    editform: {
      required: true,
      type: Object,
    },
  },
  computed: {
    childdialogshow: {
      get() {
        return this.dialogshow;
      },
      set(val) {
        this.$emit("update:dialogshow", val);
      },
    },
  },
  created() {
    if (this.isedit) {
      this.createform = this.editform;
    }
  },
  data() {
    return {
      createform: {
        Id: 0,
        TicketName: "",
        TicketTitle: "",
        ServicePhone: "",
        RateRemarkDisplay: false,
        HistoryAmountDisplay: false,
        EntrancecountDisplay: false,
        RateRemark: "",
        RemindDisplay: true,
        ExtColMark: false,
        ExtColName: "",
        ExtColValue: "",
        ScanType: 1,
        RemindRemark:
          "车辆出场时，请及时扫码支付停车费用，如未及时缴费，车辆将继续计时并可能产生额外的停车费用！",
        CreateTime: "2022-08-05T05:27:18.838Z",
        CreateUserId: 0,
      },
      rules: {
        TicketName: [
          { required: true, message: "模板名称不能为空", trigger: "blur" },
          {
            max: 10,
            message: "模板名称长度不超过12个字，请重新输入",
            trigger: "blur",
          },
        ],
        ServicePhone: [
          { required: true, message: "服务电话不能为空", trigger: "blur" },
          {
            max: 20,
            message: "服务电话长度不超过12个字，请重新输入",
            trigger: "blur",
          },
        ],
        TicketTitle: [
          { required: true, message: "小票标题不能为空", trigger: "blur" },
          {
            max: 20,
            message: "小票标题长度不超过20个字，请重新输入",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    save() {
      this.$refs.createform.validate((valid) => {
        if (valid) {
          if (!this.isedit) {
            create(this.createform).then((res) => {
              this.$message({
                message: "新增小票成功！",
                type: "success",
              });
              this.childdialogshow = false;
              this.$emit("savecomplete", res);
            });
          } else {
            edit(this.createform).then((res) => {
              this.$message({
                message: "保存成功！",
                type: "success",
              });
              this.childdialogshow = false;
              this.$emit("savecomplete");
            });
          }
        }
      });
    },
    cancel() {
      this.$emit("cancelcomplete");
    },
  },
};
</script>